import img from "../Assete/studioImag/Image.webp";
import imge1 from "../Assete/rentalSpace/s01.jpg";
import imge2 from "../Assete/rentalSpace/s02.jpg";
import imge3 from "../Assete/rentalSpace/s03.jpg";
import imge4 from "../Assete/rentalSpace/s04.jpg";
import imge5 from "../Assete/rentalSpace/s05.jpg";
import imge6 from "../Assete/rentalSpace/s06.jpg";
import imge7 from "../Assete/rentalSpace/s07.jpg";
import imge8 from "../Assete/rentalSpace/s08.jpg";
import imge9 from "../Assete/rentalSpace/10.jpg";
import imge10 from "../Assete/rentalSpace/9.jpg";
// import imge3 from "../Assete/rentalSpace/s03.jpg";
import img1 from "../Assete/propsImages/Antique Gold Textured Decorative Jar.webp";
import img2 from "../Assete/propsImages/Antique Gold Vine Candle Tree with Floral Accents.webp";
import img3 from "../Assete/propsImages/Artisan Decorative Pot Stand.webp";
import img4 from "../Assete/propsImages/Beautifully Crafted Vintage-Style Urn with White Blooms.webp";
import img5 from "../Assete/propsImages/Bold Scarlet Velvet Fabric Chaise Lounge.webp";
import img6 from "../Assete/propsImages/Classic Red Bloom Pedestal Planters.webp";
import img7 from "../Assete/propsImages/Classic White Pedestal Vase with Vibrant Pink Lilies.webp";
import img8 from "../Assete/propsImages/Classic White Urn Planters with Green Topiary Balls.webp";
import img9 from "../Assete/propsImages/Crystal Pendant Floor Lamp with Sleek Design.webp";
import img10 from "../Assete/propsImages/Elegant Corinthian White Pedestal with Floral Arrangement.webp";
import img11 from "../Assete/propsImages/Elegant Golden Bloom in Pink Marble Pots.webp";
import img12 from "../Assete/propsImages/Festive and Love-Themed Bottle Decor Pair.webp";
import img13 from "../Assete/propsImages/Golden Bloom and Green Charm potted plants.webp";
import img14 from "../Assete/propsImages/Golden Elegance Butterfly Stand.webp";
import img15 from "../Assete/propsImages/Golden Foliage in Elegant White Potted Set.webp";
import img16 from "../Assete/propsImages/Golden Glow Bird Sculptures.webp";
import img17 from "../Assete/propsImages/Golden Harmony Circular Nature Sculpture.webp";
import img18 from "../Assete/propsImages/Handcrafted Rustic Wooden Truck Decor.webp";
import img19 from "../Assete/propsImages/Heritage Charkha and Pot Set Decor.webp";
import img20 from "../Assete/propsImages/Luminous Golden Elegance Cylindrical Lanterns.webp";
import img21 from "../Assete/propsImages/Modern Radiance Circle & Artistic Decorative Sculpture.webp";
import img22 from "../Assete/propsImages/Multi-Purpose Wooden Ladder Stool.webp";
import img23 from "../Assete/propsImages/Opulent Golden Blooms in Black Marble Pots.webp";
import img24 from "../Assete/propsImages/Ornate Metallic Floral Pedestal.webp";
import img25 from "../Assete/propsImages/Radiant Gold Cylinder Vase with Lush Pink and White Blooms.webp";
import img26 from "../Assete/propsImages/Regal Gold Birdcage Duo with Decorative Stands.webp";
import img27 from "../Assete/propsImages/Regal Gold Chandelier Floor Light.webp";
import img28 from "../Assete/propsImages/Rustic Heritage Lantern Set.webp";
import img29 from "../Assete/propsImages/Rustic Wooden Dining Chair with Cross-Back Design.webp";
import img30 from "../Assete/propsImages/Set of Artificial Succulent Quartet Potted Plants.webp";
import img31 from "../Assete/propsImages/Set of Four Vintage Drip Candle Set.webp";
import img32 from "../Assete/propsImages/Square Slatted Table and Four Matching Foldable Chairs.webp";
import img33 from "../Assete/propsImages/Starry Ambition Bottle Decor.webp";
import img34 from "../Assete/propsImages/Textured White Vase with Vibrant Pink Blooms.webp";
import img35 from "../Assete/propsImages/Traditional Wooden Drums, The Classic Folk Percussion Set.webp";
import img36 from "../Assete/propsImages/Trio Mosaic Lantern Table Lamp.webp";
import img37 from "../Assete/propsImages/Turkish Mosaic Triple Lantern Table Lamp.webp";
import img38 from "../Assete/propsImages/Two Decorative Starlight Glow Accent Set.webp";
import img39 from "../Assete/propsImages/Two Golden Grace Deer Figurine Set.webp";
import img40 from "../Assete/propsImages/Two Heartlight Glow Accent Set.webp";
import img41 from "../Assete/propsImages/Unique Circular Ring-Patterned Golden Base.webp";
import img42 from "../Assete/propsImages/Velvet Shell Accent Chair Set with Ottoman.webp";
import img43 from "../Assete/propsImages/Vibrant Artisan Mortar and Pot Set.webp";
import img44 from "../Assete/propsImages/Victorian Elegance Vintage-Style Candleholder Set.webp";
import img45 from "../Assete/propsImages/Vintage Gold Bicycle Planter with Faux Greenery.webp";
import img46 from "../Assete/propsImages/Vintage Round Design Glow Lantern Duo.webp";
import img47 from "../Assete/propsImages/White and Earthy Brown Geometric Display Blocks Set.webp";
import img48 from "../Assete/propsImages/White Glow Lantern-Style Frames.webp";

export const studioData = [
    {
        imgae: img,
        headging: "CAPTURE YOUR VISION ANYWHERE!",
        tittle: "Stunning Locations for Bridal Photography",
        text1:"Experience the perfect blend of artistic themes at NaskStudio.",
        text2:"At NaskStudio, you have the freedom to shoot anywhere or everywhere across our studio.",
        aminties: [
            "Unique sets ranging from floral designs to rustic doors and exotic arches.",
            "Meticulously crafted backdrops for stunning visuals.",
            // "Ideal for portraits, bridal, fashion, and product shoots.",
            "Optimized for natural and artificial light.",
            "Centrally located for easy access.",

        ],
        four_hours_price: "Rs.18,000",
        tow_hours_price: "Rs.12,000",
        // eight_hours_price: "Rs.25,000",
    },
    // {
    //     imgae: img2,
    //     headging: "TRANSPARENT & MEASUREABLE",
    //     tittle: "FOR BRANDS / BUSINESSES",
    //     aminties: [
    //         "- Over 50,000 square feet covered area with a wide variety of thematic locations to shoot in one place",
    //         "- Situated in the middle of the city, Lahore",
    //         "- Shoot anywhere or everywhere all over the studio",
    //         "- Indoor & Outdoor options",

    //     ],
    //     four_hours_price: "Rs.18,000",
    //     tow_hours_price: "Rs.12,000",
    // }
]
export const studioSpace=[
    {
        image:imge10,
        title:"MAKEUP ROOM",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        fixed_price: "Rs.5,000",
        aminties: [
            "Separate Room",
            "2 Vanity Mirrors with Makeup Chairs",
            // "Ideal for portraits, bridal, fashion, and product shoots.",
            "Separate Changing Area",
            // "Centrally located for easy access.",

        ],
        // tow_hours_price: "Rs.12,000",
        // eight_hours_price: "Rs.25,000",
    },
    {
        image:imge1,
        title:"SET 01",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        four_hours_price: "Rs.15,000",
        tow_hours_price: "Rs.12,000",
        eight_hours_price: "Rs.25,000",
    },
    {
        image:imge2,
        title:"SET 02",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        four_hours_price: "Rs.15,000",
        tow_hours_price: "Rs.12,000",
        eight_hours_price: "Rs.25,000",
    },
    {
        image:imge3,
        title:"SET 03",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        four_hours_price: "Rs.15,000",
        tow_hours_price: "Rs.12,000",
        eight_hours_price: "Rs.25,000",
    },
    {
        image:imge4,
        title:"SET 04",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        four_hours_price: "Rs.15,000",
        tow_hours_price: "Rs.12,000",
        eight_hours_price: "Rs.25,000",
    },
    {
        image:imge5,
        title:"SET 05",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        four_hours_price: "Rs.15,000",
        tow_hours_price: "Rs.12,000",
        eight_hours_price: "Rs.25,000",
    },
    {
        image:imge6,
        title:"SET 06",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        four_hours_price: "Rs.15,000",
        tow_hours_price: "Rs.12,000",
        eight_hours_price: "Rs.25,000",
    },
    {
        image:imge7,
        title:"SET 07",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        four_hours_price: "Rs.15,000",
        tow_hours_price: "Rs.12,000",
        eight_hours_price: "Rs.25,000",
    },
    {
        image:imge8,
        title:"SET 08",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        four_hours_price: "Rs.15,000",
        tow_hours_price: "Rs.12,000",
        eight_hours_price: "Rs.25,000",
    },
    {
        image:imge9,
        title:"INFINITY",
        text:"Please feel free to contact us now via WhatsApp or call us at +92 305 111 5501 to book.",
        four_hours_price: "Rs.15,000",
        tow_hours_price: "Rs.12,000",
        eight_hours_price: "Rs.25,000",
    },
]
export const products = [
    {
        image: img1,
        title: "Antique Gold Textured Decorative Jar",
        price: "Rs.1,000.00"
    },
    {
        image: img2,
        title: "Antique Gold Vine Candle Tree with Floral Accents",
        price: "Rs.1,500.00"
    },
    {
        image: img3,
        title: "Artisan Decorative Pot Stand",
        price: "Rs.700.00"
    },
    {
        image: img4,
        title: "Beautifully Crafted Vintage-Style Urn with White Blooms",
        price: "Rs.1,000.00"
    },
    {
        image: img5,
        title: "Bold Scarlet Velvet Fabric Chaise Lounge",
        price: "Rs.5,000.00"
    },
    {
        image: img6,
        title: "Classic Red Bloom Pedestal Planters",
        price: "Rs.750.00"
    },
    {
        image: img7,
        title: "Classic White Pedestal Vase with Vibrant Pink Lilies",
        price: "Rs.750.00"
    },
    {
        image: img8,
        title: "Classic White Urn Planters with Green Topiary Balls",
        price: "Rs.750.00"
    },
    {
        image: img9,
        title: "Crystal Pendant Floor Lamp with Sleek Design",
        price: "Rs.1,500.00"
    },
    {
        image: img10,
        title: "Elegant Corinthian White Pedestal with Floral Arrangement",
        price: "Rs.850.00"
    },
    {
        image: img11,
        title: "Elegant Golden Bloom in Pink Marble Pots",
        price: "Rs.650.00"
    },
    {
        image: img12,
        title: "Festive and Love-Themed Bottle Decor Pair",
        price: "Rs.700.00"
    },
    {
        image: img13,
        title: "Golden Bloom and Green Charm potted plants",
        price: "Rs.500.00"
    },
    {
        image: img14,
        title: "Golden Elegance Butterfly Stand",
        price: "Rs.500.00"
    },
    {
        image: img15,
        title: "Golden Foliage in Elegant White Potted Set",
        price: "Rs.650.00"
    },
    {
        image: img16,
        title: "Golden Glow Bird Sculptures",
        price: "Rs.500.00"
    },
    {
        image: img17,
        title: "Golden Harmony Circular Nature Sculpture",
        price: "Rs.500.00"
    },
    {
        image: img18,
        title: "Handcrafted Rustic Wooden Truck Decor",
        price: "Rs.500.00"
    },
    {
        image: img19,
        title: "Heritage Charkha and Pot Set Decor",
        price: "Rs.500.00"
    },
    {
        image: img20,
        title: "Luminous Golden Elegance Cylindrical Lanterns",
        price: "Rs.1,500.00"
    },
    {
        image: img21,
        title: "Modern Radiance Circle & Artistic Decorative Sculpture",
        price: "Rs.500.00"
    },
    {
        image: img22,
        title: "Multi-Purpose Wooden Ladder Stool",
        price: "Rs.1,200.00"
    },
    {
        image: img23,
        title: "Opulent Golden Blooms in Black Marble Pots",
        price: "Rs.650.00"
    },
    {
        image: img24,
        title: "Ornate Metallic Floral Pedestal",
        price: "Rs.1,000.00"
    },
    {
        image: img25,
        title: "Radiant Gold Cylinder Vase with Lush Pink and White Blooms",
        price: "Rs.1,000.00"
    },
    {
        image: img26,
        title: "Regal Gold Birdcage Duo with Decorative Stands",
        price: "Rs.1,600.00"
    },
    {
        image: img27,
        title: "Regal Gold Chandelier Floor Light",
        price: "Rs.2000.00"
    },
    {
        image: img28,
        title: "Rustic Heritage Lantern Set",
        price: "Rs.1,000.00"
    },
    {
        image: img29,
        title: "Rustic Wooden Dining Chair with Cross-Back Design",
        price: "Rs.1,200.00"
    },
    {
        image: img30,
        title: "Set of Artificial Succulent Quartet Potted Plants",
        price: "Rs.500.00"
    },
    {
        image: img31,
        title: "Set of Four Vintage Drip Candle Set",
        price: "Rs.1,000.00"
    },
    {
        image: img32,
        title: "Square Slatted Table and Four Matching Foldable Chairs",
        price: "Rs.5000.00"
    },
    {
        image: img33,
        title: "Starry Ambition Bottle Decor",
        price: "Rs.700.00"
    },
    {
        image: img34,
        title: "Textured White Vase with Vibrant Pink Blooms",
        price: "Rs.300.00"
    },
    {
        image: img35,
        title: "Traditional Wooden Drums, The Classic Folk Percussion Set",
        price: "Rs.500.00"
    },
    {
        image: img36,
        title: "Trio Mosaic Lantern Table Lamp",
        price: "Rs.1,000.00"
    },
    {
        image: img37,
        title: "Turkish Mosaic Triple Lantern Table Lamp",
        price: "Rs.1,000.00"
    },
    {
        image: img38,
        title: "Two Decorative Starlight Glow Accent Set",
        price: "Rs.500.00"
    },
    {
        image: img39,
        title: "Two Golden Grace Deer Figurine Set",
        price: "Rs.500.00"
    },
    {
        image: img40,
        title: "Two Heartlight Glow Accent Set",
        price: "Rs.500.00"
    },
    {
        image: img41,
        title: "Unique Circular Ring-Patterned Golden Base",
        price: "Rs.1,500.00"
    },
    {
        image: img42,
        title: "Velvet Shell Accent Chair Set with Ottoman",
        price: "Rs.5000.00"
    },
    {
        image: img43,
        title: "Vibrant Artisan Mortar and Pot Set",
        price: "Rs.500.00"
    },
    {
        image: img44,
        title: "Victorian Elegance Vintage-Style Candleholder Set",
        price: "Rs.1,000.00"
    },
    {
        image: img45,
        title: "Vintage Gold Bicycle Planter with Faux Greenery",
        price: "Rs.1,000.00"
    },
    {
        image: img46,
        title: "Vintage Round Design Glow Lantern Duo",
        price: "Rs.800.00"
    },
    {
        image: img47,
        title: "White and Earthy Brown Geometric Display Blocks Set",
        price: "Rs.1,000.00"
    },
    {
        image: img48,
        title: "White Glow Lantern-Style Frames",
        price: "Rs.500.00"
    }
];
